export enum SaleNumeration {
    Company = "company",
    Shop = "shop",
}
